import PropTypes from 'prop-types';

import StagesController from './StageController.js';

import WithType from './../WithType';

import mainConfig from './../../../../config/main.config';

import nodes from './../../../../config/map-nodes.js';

import locations from './../../../../config/map-locations.js';

let _this = {};

/**
 * Handles map tool for debugging and creating/editing locations and nodes.
 * Config property 'testing' must be true so this gets instantiated.
 */
class StageMapTool extends StagesController {
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        const iframe = document.querySelector('#load_iframe');
        this.iframe_document = iframe.contentDocument || iframe.contentWindow.document;
        this.occ_current = this.getFrame().occ_sprite;

        _this = this;
        this.createMapElements();
    }

    /** Create HTML elements for map tool. */
    createMapElements = () => {
        const support_html = `
            <div id="map_tool_menu" style="max-height:100%;max-width:260px;border:1px solid #aaa;background-color:white;padding:8px;position:absolute;overflow:auto;z-index:9999999999!important;left:0;top:0;">
                <div style="display:flex; flex-direction:column; border:1px solid #0d6efd; padding:12px;">
                    <p style="font-weight:bold;">Novo local:</p>
                    <button id="btn_add_place" style="border:1px solid #0d6efd;">Adicionar</button>
                    <button id="btn_cancel_place" style="border:1px solid #0d6efd; margin-top:8px;" disabled>Cancelar</button>

                    <label for="name_input_place" style="display:block; margin-top:8px;">
                        <b style="color:#dc3545;">*</b>Nome/Id do local:
                    </label>
                    <input id="name_input_place" type="text" disabled style="border:1px solid #ccc; color:black;">

                    <label for="node_input" style="display:block; margin-top:8px;">
                        <b style="color:#dc3545;">*</b>ID do nó:
                    </label>
                    <input id="node_input" type="text" disabled style="border:1px solid #ccc; color:black;">

                    <button id="btn_confirm_place" disabled style="border:1px solid #0d6efd; margin-top:8px;">
                        Confirmar
                    </button>

                    <p id="status_place"></p>

                    <button id="copy_places" style="background:#0d6efd; color:white; padding:6px 12px; border:none; margin-left:auto; margin-top:8px;">
                        Copiar locais
                    </button>
                </div>

                <div style="display:flex; flex-direction:column; border:1px solid #0d6efd; padding:12px; margin-top:12px;">
                    <p style="font-weight:bold;">Novo nó:</p>

                    <button id="btn_add_node" style="border:1px solid #0d6efd;">Adicionar</button>

                    <button id="btn_cancel_node" disabled style="border:1px solid #0d6efd; margin-top:8px;">
                        Cancelar
                    </button>

                    <label for="id_input_node" style="display:block; margin-top:8px;">
                        <b style="color:#dc3545;">*</b>ID do nó:
                    </label>

                    <input id="id_input_node" type="text" disabled style="border:1px solid #ccc; color:black;">

                    <div style="display:flex; margin-top:16px;">
                        <label for="x_node" style="display:block; margin-top:8px;">X:</label>
                        <input id="x_node" type="number" disabled style="border:1px solid #ccc; color:black; margin-left:4px;">

                        <label for="y_node" style="display:block; margin-top:8px; margin-left:12px;">Y:</label>
                        <input id="y_node" type="number" disabled style="border:1px solid #ccc; color:black; margin-left:4px;">
                    </div>

                    <div id="node_rel_options">
                        <div class="related-node-section">
                            <label for="rel_node_input" style="display:block; margin-top:8px;">
                                IDs dos nós relacionados:
                            </label>
                            <input id="rel_node_input" type="text" disabled style="border:1px solid #ccc; color:black;">
                        </div>

                        <ul id="rel_nodes_list" class="node-list" style="max-height:150px; overflow:auto; margin-top:12px; padding-left:0; list-style:none;">
                        </ul>
                    </div>

                    <div style="margin-top:8px;">
                        <label for="check_not_path">Nó NÃO é caminho?</label>
                        <input id="check_not_path" type="checkbox" disabled>
                    </div>

                    <button id="btn_confirm_node" disabled style="border:1px solid #0d6efd; margin-top:16px;">
                        Confirmar
                    </button>

                    <p id="status_node"></p>

                    <button id="copy_nodes" style="background:#0d6efd; color:white; padding:6px 12px; border:none; margin-left:auto; margin-top:8px;">
                        Copiar nós
                    </button>
                </div>
            </div>`;

        document.getElementById('animation_container').insertAdjacentHTML('beforeend', support_html);
    }

    /**
     * Detects if click was inside a point; if distance between user click is less equal item_size,
     * user cliked inside item radius. Should be used only for identifying points/items that are single points,
     * not complex forms like rectangles.
     * @param {Number} x Coordinate.
     * @param {Number} y Coordinate.
     * @param {Number} item_size Size.
     * @returns {Boolean} True if click was inside node.
     */
    clickOverlaps = (x, y, item_size) => { 
        // Distance between points -> euclidian distance.
        return Math.sqrt(x * x + y * y) <= item_size;
    }

    /**
     * Draws text close to recently added shape on the same layer.
     * @param {createjs.} occ Stage to draw subtitle at.
     * @param {String} text Subtitle text.
     * @param {Number} x Coordinate.
     * @param {Number} y Coordinate.
     * @param {Number} plus_x Plus to push node inside location.
     * @param {Number} plus_y Plus to push node inside location.
     */
    drawSubtitle = (occ, text,  x, y, plus_x = 0, plus_y = 0) => {
        const label = new createjs.Text(text, '12px Arial', '#FFFFFF');
        label.x = x + plus_x;
        label.y = y + plus_y;
        label.shadow = new createjs.Shadow('#000000', 1, 1, 2);
        occ.addChild(label);
    }

    /** Copy json obj as parsed string to clipboard, if 'navigator' not available, log data. */
    copyToClipboard(event, data) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(JSON.stringify(data));
        } else {
            const json_str = JSON.stringify(data)
                .replace(/"(\w+)"\s*:/g, '$1:') // remove quotes around keys.
                .replace(/: "(\d+)"(?=,|\n|$)/g, ': $1');

            console.log('export default', json_str);
        }
    }

    /** Handles events managing the locations on the map tool. */
    setMapLocations = () => {
        const
            btn_add = document.getElementById('btn_add_place'),
            btn_confirm = document.getElementById('btn_confirm_place'),
            btn_cancel = document.getElementById('btn_cancel_place'),
            name_input = document.getElementById('name_input_place'),
            node_input = document.getElementById('node_input'),
            status_el = document.getElementById('status_place'),
            copy_places = document.getElementById('copy_places');

        const overlay_layer = new createjs.Container(); // Layer for permanent overlays (saved rectangles + labels).
        this.occ_current.addChild(overlay_layer);

        const drag_layer = new createjs.Container(); // Layer for the drag rectangle.
        this.occ_current.addChild(drag_layer);

        const
            state = {
                selecting: false,
                is_dragging: false,
                drag_start: null,
                drag_shape: null,
                local: null
            },
            listeners = {
                down: null,
                move: null,
                up: null
            };

        /** Detach click and drag related events for locations. */
        function detachStageHandlers() {
            if (listeners.down) {
                _this.occ_current.off('mousedown', listeners.down);
                listeners.down = null;
            }
            if (listeners.move) {
                _this.occ_current.off('pressmove', listeners.move);
                listeners.move = null;
            }
            if (listeners.up) {
                _this.occ_current.off('pressup', listeners.up);
                listeners.up = null;
            }
        }

        /** Clears the drag after finishing it. */
        function clearDrag() {
            drag_layer.removeAllChildren();
            state.drag_shape = null;
            state.drag_start = null;
            state.local = null;
            name_input.value = '';
            node_input.value = '';
        }

        /** After clicking button, enables the start of click and drag to form a location. */
        function beginSelection(event) {
            if (state.selecting) {
                return;
            }

            state.selecting = true;
            status_el.textContent = 'Selecione o local e confirme...';

            name_input.disabled = false;
            node_input.disabled = false;
            btn_add.disabled = true;
            btn_confirm.disabled = true;
            btn_cancel.disabled = false;

            listeners.down = _this.occ_current.on('mousedown', onDown);
            listeners.move = _this.occ_current.on('pressmove', onMove);
            listeners.up = _this.occ_current.on('pressup', onUp, null, true); // Once.
        }

        function endSelection() {
            state.selecting = false;
            state.is_dragging = false;

            status_el.textContent = '';
            btn_add.disabled = false;
            btn_confirm.disabled = true;
            btn_cancel.disabled = true;

            detachStageHandlers();
            clearDrag();
        }

        /** Acknowledge drag and set initial drag coords. */
        function onDown(event) {
            // Start a drag if we don't already have a location-rectangle for this attempt.
            if (state.is_dragging || state.drag_shape) return;

            state.drag_start = drag_layer.globalToLocal(event.stageX, event.stageY);
            state.is_dragging = true;

            state.drag_shape = new createjs.Shape();
            state.drag_shape.mouseEnabled = false;
            state.drag_shape.snapToPixel = true;
            drag_layer.addChild(state.drag_shape);
        }

        /** On dragging, draws the second point after onDown, generating a click and drag 'graphic' on the canvas. */
        function onMove(event) {
            if (!state.is_dragging || !state.drag_start || !state.drag_shape) return;

            const
                current_point = _this.occ_current.globalToLocal(event.stageX, event.stageY),
                distance_x = current_point.x - state.drag_start.x,
                distance_y = current_point.y - state.drag_start.y,
                // Normalize to top-left + positive w/h -> so the direction chosen by the user for click and drag will not matter.
                normal_x = distance_x < 0 ? state.drag_start.x + distance_x : state.drag_start.x,
                normal_y = distance_y < 0 ? state.drag_start.y + distance_y : state.drag_start.y,
                normal_w = Math.abs(distance_x),
                normal_h = Math.abs(distance_y);

            state.local = {
                x0: _this.parseToFloat(normal_x),
                y0: _this.parseToFloat(normal_y),
                x1: _this.parseToFloat(normal_x + normal_w),
                y1: _this.parseToFloat(normal_y + normal_h)
            };

            _this.drawLocationRect(state.drag_shape.graphics, true, normal_x, normal_y, normal_w, normal_h);
        }

        /** Stop altering current location rectangle. */
        function onUp(event) {
            state.is_dragging = false;
            btn_confirm.disabled = false;

            detachStageHandlers();
        }

        function registerLocation() {
            if (!state.local) return;

            const
                id = name_input.value.trim() || '',
                node = node_input.value.trim() || '',
                parsed_id = parseInt(id) || id,
                parsed_node = parseInt(node) || node;

            const rect = {...state.local, id: parsed_id, node: parsed_node};

            // Save node in memory.
            locations.push(rect);

            // Draw permanent overlay.
            const s = new createjs.Shape();
            _this.drawLocationRect(s.graphics, true, rect.x1, rect.y1, rect.x0-rect.x1, rect.y0-rect.y1);
            overlay_layer.addChild(s);

            // Update UI state.
            name_input.value = '';
            node_input.value = '';
            name_input.disabled = true;
            node_input.disabled = true;
            endSelection(); // Reset UI for next action.
        }

        this.drawMapLocations(overlay_layer);
        btn_add.addEventListener('click', beginSelection);
        btn_cancel.addEventListener('click', endSelection);
        btn_confirm.addEventListener('click', registerLocation);
        copy_places.addEventListener('click', (event) => _this.copyToClipboard(event, locations));
    }

    /** Manage menu tool for nodes. */
    setNodes = () => {
        const
            btn_add = document.getElementById('btn_add_node'),
            btn_confirm = document.getElementById('btn_confirm_node'),
            btn_cancel = document.getElementById('btn_cancel_node'),
            id_input = document.getElementById('id_input_node'),
            status_el = document.getElementById('status_node'),
            x_node = document.getElementById('x_node'),
            y_node = document.getElementById('y_node'),
            node_rel_options = document.getElementById('node_rel_options'),
            rel_nodes_list = document.getElementById('rel_nodes_list'),
            rel_node_input = document.getElementById('rel_node_input'),
            check_not_path = document.getElementById('check_not_path'),
            copy_nodes = document.getElementById('copy_nodes');

        // Layer for permanent overlays (saved nodes + labels).
        const overlay_layer = new createjs.Container();
        this.occ_current.addChild(overlay_layer);

        // Layer for the current preview node.
        const node_layer = new createjs.Container();
        this.occ_current.addChild(node_layer);

        const
            state = {
                selecting: false,
                node: null,
                nodes: [],
                removed_edges: []
            },
            listeners = {onClickNewNode: null};

        /** Remove events after After node is succesfully registered. */
        const detachStageHandlers = () => {
            if (listeners.onClickNewNode) {
                this.occ_current.removeEventListener('click', listeners.onClickNewNode);
                listeners.down = null;
            }
        }

        /** Switch attributes for enable/disable selects and inputs. */
        const switchNewNode = () => {
            status_el.textContent = (state.selecting) ? 'Selecione o local e confirme...' : '';
            btn_add.disabled = !btn_add.disabled;
            btn_cancel.disabled = !btn_cancel.disabled;
            id_input.disabled = !id_input.disabled;
            rel_node_input.disabled = !rel_node_input.disabled;
            check_not_path.disabled = !check_not_path.disabled;
        }

        /** Create/edit node. */
        function registerNode(event) {
            if (!state.node) return;

            if (!id_input.value.trim()) { // Node Id is obligatory.
                status_el.textContent = 'ID é obrigatório';
                return;
            }
            status_el.textContent = '';

            const
                {x, y, edges} = state.node,
                find_node = nodes.find(node => node.id === id_input.value.trim());

            // input_rel_node_ids -> transform all numeric IDs into integers, trim empty spaces and get valid edges.
            const input_rel_node_ids = rel_node_input.value.split(',').map(e => {
                let curr_e = e.trim();

                // If node is number, parse it to int.
                if (!isNaN(curr_e)) {
                    curr_e = parseInt(curr_e);
                }

                return curr_e;
            }).filter(Boolean);

            const
                id = id_input.value.trim(),
                parsed_id = parseInt(id) || id;

            let data = {
                id: parsed_id,
                x: _this.parseToFloat(x),
                y: _this.parseToFloat(y),
            };

            // Compare user inserted edges and add unique if node already have any.
            if (edges) {
                data.edges = [...new Set([...input_rel_node_ids, ...edges])];
            } else {
                data.edges = input_rel_node_ids;
            }

            // Set checked for node not_path - this node will only be considered a destination, not a path.
            if (check_not_path.checked) {
                data.not_path = 1;
            }

            const current_id = data.id;

            // If nodes doesn't exist, add it, else edit object reference stored at nodes.
            if (!find_node) {
                data.edges = input_rel_node_ids;
                nodes.push(data);
            } else {
                find_node.id = current_id;
                find_node.x = data.x;
                find_node.y = data.y;
                find_node.edges = data.edges;
                if (check_not_path.checked) {
                    find_node.not_path = check_not_path.checked;
                }
            }

            // Remove reverse edges from nodes that had connections removed.
            for (const removed_id of state.removed_edges || []) {
                const target = nodes.find(node => node.id === removed_id);
                if (target) {
                    target.edges = target.edges.filter(edge => edge !== current_id);
                }
            }

            // Add missing reverse edges on each target.
            for (const target_id of data.edges || []) {
                const target = nodes.find(node => node.id === target_id);
                if (!target.edges.includes(current_id)) {
                    target.edges.push(current_id);
                }
            }

            // Add node properties to current node in state.
            state.node.id = data.id;
            state.node.edges = data.edges;
            state.removed_edges = [];

            // Draw node and update UI state.
            overlay_layer.removeAllChildren();
            //_this.drawNodes(overlay_layer, true);
            _this.drawNodes(overlay_layer, false);

            state.selecting = false;
            btn_confirm.disabled = true;
            state.node = null;
            x_node.disabled = true;
            y_node.disabled = true;
            x_node.value = '';
            y_node.value = '';
            rel_nodes_list.replaceChildren();
            id_input.value = '';
            check_not_path.checked = false;
            switchNewNode();
            rel_node_input.value = ''; // Reset input after setting related node.
            detachStageHandlers();
        }

        function clickOverlapsNode(clicked_point) {
            return nodes.find(({x, y}) => {
                const
                    difference_x = clicked_point.x - x,
                    difference_y = clicked_point.y - y;

                return _this.clickOverlaps(difference_x, difference_y, _this.props.node_size);
            });
        }

        /** Add clicked node as neighbor to current node and vice-versa. */
        function onClickSelectNeighbor(event) {
            const
                clicked_point = overlay_layer.globalToLocal(event.stageX, event.stageY),
                clicked_node = clickOverlapsNode(clicked_point);

            // If a node is selected and then another one (different than one at state.node) then both become neighbors (edges).
            if (!clicked_node || clicked_node.id === state.node.id) {
                return;
            }

            const
                clicked_node_id = clicked_node.id,
                parsed_clicked_node_id = parseInt(clicked_node_id) || clicked_node_id,
                other_node = nodes.find(node => node.id === parsed_clicked_node_id);

            rel_node_input.value += `${other_node.id},`;
        }

        function onClickNewNode(event) {
            const
                clicked_point = overlay_layer.globalToLocal(event.stageX, event.stageY),
                {x, y} = clicked_point;

            state.node = {x, y};
            // Set UI tool state.
            status_el.textContent = '';
            x_node.value = _this.parseToFloat(x);
            y_node.value = _this.parseToFloat(y);
            x_node.disabled = false;
            y_node.disabled = false;
            btn_confirm.disabled = false;
            node_rel_options.style.display = 'initial';
            rel_node_input.disabled = false;

            // Draw node.
            const node_graphic = new createjs.Graphics();
            node_graphic.beginStroke(_this.props.node_border_color);
            node_graphic.beginFill(_this.props.node_adding_color);

            const node_size = _this.props.node_size;
            node_graphic.drawCircle(x, y, node_size, node_size);

            node_layer.addChild(new createjs.Shape(node_graphic));
        }

        /** Handles start of location select, when mouse landed (mousedown event). */
        function beginSelection(event) {
            // Find highest numbered node starting with letter 'n'.
            const numeric_ids = nodes.map(({id}) => id.trim())
                .filter(id => id.startsWith('n'))
                .map(id => parseInt(id.slice(1)))
                .filter(num => !isNaN(num));

            const next_id = numeric_ids.length > 0 ? Math.max(...numeric_ids) + 1 : 1;
            id_input.value = `n${next_id}`;
            state.selecting = true;
            switchNewNode();
            listeners.onClickNewNode = _this.occ_current.on('click', onClickNewNode, null, true); // Event happens once per selection.
        }

        function cancelSelection(event) {
            state.removed_edges = [];

            state.selecting = false;
            btn_confirm.disabled = true;
            id_input.value = '';
            rel_node_input.value = '';
            x_node.value = '';
            y_node.value = '';
            x_node.disabled = true;
            y_node.disabled = true;
            check_not_path.checked = false;
            switchNewNode();
            rel_nodes_list.replaceChildren();
            node_layer.removeAllChildren();

            detachStageHandlers();
        }

        /** Updated node position when user interacts with x and y inputs. */
        function redrawNode(event) {
            const
                x = x_node.value,
                y = y_node.value,
                parsed_x = _this.parseToFloat(x),
                parsed_y = _this.parseToFloat(y);

            state.node.x = parsed_x;
            state.node.y = parsed_y;
            node_layer.removeAllChildren();
            const node_size = _this.props.node_size;
            _this.drawNodeCircle(node_layer, parsed_x, parsed_y, node_size, node_size);
        }

        /** If a node was clicked set it to be edited. */
        function clickOnNode(event) {            
            if (state.selecting) return;

            const
                clicked_point = _this.occ_current.globalToLocal(event.stageX, event.stageY),
                clicked_node = clickOverlapsNode(clicked_point);

            if (!clicked_node) return; // Click didn't select a node -> early return.

            state.current_node = clicked_node;
            // If a node was clicked, set it to be edited on the node menu tool.
            switchNewNode();
            state.node = {id:clicked_node.id, x: clicked_node.x, y: clicked_node.y, edges: clicked_node.edges};
            state.selecting = true;
            id_input.value = clicked_node.id;
            x_node.value = clicked_node.x;
            y_node.value = clicked_node.y;
            check_not_path.checked = clicked_node.not_path;
            x_node.disabled = false;
            y_node.disabled = false;

            rel_node_input.disabled = false;
            btn_confirm.disabled = false;

            function removeId(event) {
                const node_id = event?.target?.dataset?.id;
                const parent = event?.target?.parentNode;

                // Mark this edge to be removed later.
                state.removed_edges.push(node_id);

                // Remove from display and local temp edges.
                state.node.edges = state.node.edges.filter(edge => edge !== node_id);

                parent.remove();
            }

            // Add node edges at HTML list.
            clicked_node.edges && clicked_node.edges.forEach(edge => {
                // Create <li>.
                const
                    li = document.createElement('li'),
                    text = document.createTextNode(`ID: ${edge}`);

                li.append(text);

                // Create <button>.
                const
                    btn = document.createElement('button'),
                    btn_x = document.createTextNode('X');

                btn.append(btn_x);
                btn.dataset.id = edge;

                btn.addEventListener('click', removeId, {once: true}); // Remove id event.

                // Append elements to list.
                li.append(btn)
                rel_nodes_list.append(li);
            });

            // Listens to click for other nodes - so they can be related to node being created.
            _this.occ_current.on('click', onClickSelectNeighbor, null);
        };

        // Init all events and show nodes.
        //this.drawNodes(overlay_layer, true);
        this.drawNodes(overlay_layer, false);
        btn_add.addEventListener('click', beginSelection);
        btn_cancel.addEventListener('click', cancelSelection);
        btn_confirm.addEventListener('click', registerNode);
        x_node.addEventListener('change', redrawNode);
        y_node.addEventListener('change', redrawNode);
        copy_nodes.addEventListener('click', (event) => _this.copyToClipboard(event, nodes));
        _this.occ_current.on('click', clickOnNode);
    }

    /**
     * Draw a line on the indicated ocurrence.
     * @param {createjs.DisplayObject} occ Ocurrence to draw the lines at.
     * @param {String} x0 Coodinate for initial x.
     * @param {String} y0 Coodinate for initial y.
     * @param {String} x1 Coodinate for final x.
     * @param {String} y1 Coodinate for final y.
     * @param {String} color Line color.
     */
    drawLine = (occ, x0, y0, x1, y1, color) => {
        const line = new createjs.Shape();

        line.graphics
            .setStrokeStyle(1)
            .beginStroke(color)
            .moveTo(parseFloat(x0), parseFloat(y0))
            .lineTo(parseFloat(x1), parseFloat(y1));

        occ.addChild(line);
    }

    /**
     * Draws rectangle for a map location.
     * @param {createjs.Graphics} location_graphic Reference to graphic object.
     * @param {Boolean} should_clear Clears previous nodes on same stage.
     * @param {String} x Location coordinate.
     * @param {String} y Location coordinate.
     * @param {Number} width Location width.
     * @param {Number} height Location height.
     */
    drawLocationRect = (location_graphic, should_clear, x, y, width, height) => {
        should_clear && location_graphic.clear() // Clear at start guarantees node will not overlap other existing ones.

        const {location_test_border_color, location_test_color} = this.props;

        location_graphic.setStrokeStyle(2)
            .beginStroke(location_test_border_color)
            .beginFill(location_test_color)
            .drawRect(x, y, width, height)
            .endFill()
            .endStroke();
    }

    /**
     * Draw all map locations and subtitles for location name.
     * @param {createjs.DisplayObject} occ Ocurrence to draw locations at.
     */
    drawMapLocations = (occ) => {
        const map_shape = new createjs.Shape();

        locations.length && locations.forEach(({x0, y0, x1, y1}) => {
            this.drawLocationRect(map_shape.graphics, false, x0, y0, x1-x0, y1-y0);
        });

        occ.addChild(map_shape);
    }

    /**
     * Draw a createjs circle.
     * @param {createjs.DisplayObject} occ Stage to draw circle at.
     * @param {Number} x0 Initial x.
     * @param {Number} y0 Initial y.
     * @param {Number} x1 Final x.
     * @param {Number} y1 Final y.
     */
    drawNodeCircle = (occ, x0, y0, x1, y1) => {
        const graphic = new createjs.Graphics();

        graphic.beginStroke(this.props.node_border_color);
        graphic.beginFill(this.props.node_color);
        graphic.drawCircle(x0, y0, x1, y1);
        occ.addChild(new createjs.Shape(graphic));
    }

    /**
     * Draw nodes and link their edges.
     * @param {createjs.DisplayObject} occ Ocurrence to draw nodes at.
     * @param {Boolean} draw_subtitles If true, draw location name as a subtitle close to it.
     */
    drawNodes = (occ, draw_subtitles = true) => {
        occ.removeAllChildren();
        const node_size = _this.props.node_size;

        nodes.forEach(node => {
            this.drawNodeCircle(occ, node.x, node.y, node_size, node_size);
            if (draw_subtitles) this.drawSubtitle(occ, node.id, node.x, node.y, 0, 6);

            // Drawing edge lines (linking nodes to their edges).
            node.edges && node.edges.forEach(edge_id => {
                const edge_node = nodes.find(n => n.id === edge_id);

                if (edge_node) {
                    this.drawLine(occ, node.x, node.y, edge_node.x, edge_node.y, '#000000');
                }
            });
        });
    }

    /** Runs when config attribute testing is true. Only needed for using map tools or debugging; creates HTML elements for supporting element creation. */
    makeTest = () => {
        // Make locations and node menu tool show.
        const {show_map_tool, show_nodes, show_locations} = this.props;
        if (show_map_tool) document.getElementById('map_tool_menu').style.display = 'initial';
        show_nodes && this.setNodes();
        show_locations && this.setMapLocations();
    }
};

StageMapTool.propTypes = {
    show_map_tool: PropTypes.bool,
    location_test_color: PropTypes.string,
    location_test_border_color: PropTypes.string,
    show_nodes: PropTypes.bool,
    node_adding_color: PropTypes.string,
    node_color: PropTypes.string,
    node_border_color: PropTypes.string,
    node_size: PropTypes.number,
    show_locations: PropTypes.bool,
    color_location: PropTypes.string
};

/**
 *
 * @type {{}}
 */
StageMapTool.defaultProps = {
    current_name: null,
    current_page: null,
    ...mainConfig.map
};

export default WithType(StageMapTool, {className: 'StageMapTool'});